var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.408.668a2.723 2.723 0 0 0-2.717 2.713v1.6H1.907a.636.636 0 0 0-.06 0 .636.636 0 0 0-.573.582L.002 20.324a.636.636 0 0 0 .634.69h15.619a.636.636 0 0 0 .634-.69l-1.273-14.76a.636.636 0 0 0-.633-.583H12.2v-1.6A2.72 2.72 0 0 0 9.487.668H7.408zm0 1.272h2.079c.81 0 1.442.63 1.442 1.441v1.6H5.963v-1.6c0-.81.635-1.441 1.445-1.441zM2.49 6.254H4.69V8.14a.636.636 0 0 0 1.272 0V6.254h4.966V8.14a.636.636 0 0 0 1.271 0V6.254h2.202l1.159 13.488H1.33L2.49 6.254z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBagIcon);
export default __webpack_public_path__ + "static/media/shopping-bag-icon.3458da1e96cf02fdd05d585c3c65d238.svg";
export { ForwardRef as ReactComponent };